import { bridge } from "@dinahmoe/dmafjs-core";

import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class UrlMediaHtml extends VisualSuperHtml {
  handlers = this.extendParentHandlers({
    "media.url": this._setUrl,
    "media.crossOrigin": this._setCrossOrigin,
  });

  setProps(eNode) {
    const type = eNode.props["media.type"];
    const url = eNode.props["media.url"];

    const element = document.createElement(type);

    eNode.element = element;
    this._setCrossOrigin(eNode);

    element.setAttribute("draggable", "false");
    element.setAttribute("src", url);
    element.controls = eNode.props["media.controls"];
    element.muted = eNode.props["media.muted"];
    element.autoplay = eNode.props["media.autoPlay"];
    element.loop = eNode.props["media.loop"];

    element.style.pointerEvents = "auto";

    eNode.element = create(eNode, element);

    super.setProps(eNode);

    element.addEventListener("loadedmetadata", () => {
      const isVideo = type === "video";
      bridge.update({
        uid: eNode.uid,
        key: `${type}_loaded`,
        value: {
          id: eNode.props["id"],
          naturalWidth: isVideo ? element.videoWidth : 0,
          naturalHeight: isVideo ? element.videoHeight : 0,
        },
        sender: "browser",
      });
    });

    element.addEventListener("error", () =>
      bridge.update({
        uid: eNode.uid,
        key: `${type}_load_error`,
        value: {
          id: eNode.props["id"],
        },
        sender: "browser",
      }),
    );
  }

  _setUrl(eNode) {
    if (eNode.element) {
      eNode.element.setAttribute("src", eNode.props["media.url"]);
    }
  }

  _setCrossOrigin(eNode) {
    if (eNode.props["media.crossOrigin"] !== "none") {
      eNode.element.setAttribute("crossorigin", eNode.props["media.crossOrigin"]);
    } else {
      eNode.element.removeAttribute("crossorigin");
    }
  }
}

const urlMediaHtml = new UrlMediaHtml("visual:urlMedia");
visualEntities.set("visual:urlMedia", urlMediaHtml);
export { UrlMediaHtml, urlMediaHtml };
